import { render } from "./CheckOTP.vue?vue&type=template&id=2e12750a&scoped=true"
import script from "./CheckOTP.vue?vue&type=script&lang=js"
export * from "./CheckOTP.vue?vue&type=script&lang=js"

import "./CheckOTP.vue?vue&type=style&index=0&id=2e12750a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e12750a"]])

export default __exports__